/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { PolicyBuild } from './PolicyBuild';

export type PolicyVersionRetrieval = {
    uuid: string;
    policy: string;
    version: string;
    status?: PolicyVersionRetrieval.status;
    readonly added_at?: string;
    builds: Array<PolicyBuild>;
}

export namespace PolicyVersionRetrieval {

    export enum status {
        DRAFT = 'draft',
        PENDING = 'pending',
        APPROVED = 'approved',
    }


}
